import React from "react";

function Map() {
  return (
    <div>
      <section className="contact-map">
        <div className="container">
          <div className="google-map google-map__contact">
            <iframe
              title="template google map"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3888.432810547622!2d77.55746297507596!3d12.94413358736878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU2JzM4LjkiTiA3N8KwMzMnMzYuMSJF!5e0!3m2!1sen!2sin!4v1780054034016!5m2!1sen!2sin"
              className="map__contact"
              allowFullScreen=""
            />
            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3888.432810547622!2d77.55746297507596!3d12.94413358736878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU2JzM4LjkiTiA3N8KwMzMnMzYuMSJF!5e0!3m2!1sen!2sin!4v1780054034016!5m2!1sen!2sin" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
          </div>
          {/* /.google-map */}
        </div>
        {/* /.container-fluid */}
      </section>
    </div>
  );
}

export default Map;
